import { Button, Col, Row } from "antd";
import { Plus } from "lucide-react";

import { AdminMenuLayout, ModalBanners } from "../../../shared/components";
import { WrapperCard } from "./styled";
import { TableBannersSortable } from "./TableBannersSortable";
import { useBanners } from "../hooks";
import { useSelector } from "react-redux";
import { selectModalBanners } from "../../../redux";
import { FormProvider } from "react-hook-form";
import { LucideIcon } from "../../../shared/components/ui/icons/LucideIcon";

export const Banners = () => {
  const modalBanners = useSelector(selectModalBanners);
  const {
    isUpdateBanner,
    isLoading,
    formMethodsCreate,
    formMethodsUpdate,
    changeModalBannersState,
    onSubmitCreateOrUpdate,
  } = useBanners();

  return (
    <AdminMenuLayout pageDescription="Banners" title="Banners">
      <WrapperCard>
        <Row
          gutter={[8, 8]}
          style={{
            padding: "10px",
            width: "100%",
          }}
        >
          <Col
            span={24}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              type="primary"
              size="large"
              onClick={changeModalBannersState}
              style={{
                borderRadius: "8px",
                height: "40px",
                fontWeight: 500,
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <LucideIcon>
                <Plus size={18} />
              </LucideIcon>
              Agregar nuevo banner
            </Button>
          </Col>
        </Row>
        <TableBannersSortable />

        {modalBanners && isUpdateBanner && (
          <FormProvider {...formMethodsUpdate}>
            <ModalBanners
              isLoading={isLoading}
              changeModalBannersState={changeModalBannersState}
              onSubmitCreateOrUpdate={onSubmitCreateOrUpdate}
            />
          </FormProvider>
        )}
        {modalBanners && !isUpdateBanner && (
          <FormProvider {...formMethodsCreate}>
            <ModalBanners
              isLoading={isLoading}
              changeModalBannersState={changeModalBannersState}
              onSubmitCreateOrUpdate={onSubmitCreateOrUpdate}
            />
          </FormProvider>
        )}
      </WrapperCard>
    </AdminMenuLayout>
  );
};
